import { TAKEAWAY_ORDER_STATUSES, TAKEAWAY_SORT_KEYS } from "@seagames/contracts";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { OrdersView } from "../../components/fnb/orders-view";
import { PageSkeleton } from "../../components/accommodation/page-skeleton";
import { useGamesTimeZone } from "../../components/travel-leg-form";
import { useDefaultGamesId } from "../../lib/competition/games";
import { canSeeHostOrders } from "../../lib/fnb/access";
import { keysetSearch, searchText } from "../../lib/list-page/list-search";

/**
 * Takeaway orders (her `#/fnb/orders`). URL = the list's state in the API's
 * own keys, every param lenient (`keysetSearch`): `q status late
 * dining_hall_id date sort` + the keyset `cursor` / `prev` / `limit`.
 * A NOC reads its own orders on the index page instead.
 */
export const Route = createFileRoute("/_app/logistics/food-beverages/orders")({
	validateSearch: keysetSearch({
		q: searchText(),
		status: z
			.string()
			.max(200)
			.refine((v) => v.split(",").every((s) => (TAKEAWAY_ORDER_STATUSES as readonly string[]).includes(s))),
		late: z.boolean(),
		dining_hall_id: z.string().uuid(),
		date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
		sort: z.enum(TAKEAWAY_SORT_KEYS),
	}),
	beforeLoad: ({ context }) => {
		if (!canSeeHostOrders(context.session)) throw redirect({ to: "/logistics/food-beverages" });
	},
	component: OrdersPage,
});

function OrdersPage() {
	const { session } = Route.useRouteContext();
	const search = Route.useSearch();
	const navigate = Route.useNavigate();
	const gamesId = useDefaultGamesId(search.games_id);
	const timeZone = useGamesTimeZone(gamesId);
	if (!gamesId || !timeZone) return <PageSkeleton />;
	return <OrdersView session={session} gamesId={gamesId} timeZone={timeZone} search={search} navigate={navigate} canCreate />;
}
